module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vuetable-pagination-info', _vm.css.infoClass],
    domProps: {
      "innerHTML": _vm._s(_vm.paginationInfo)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-910bb7ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuetablePaginationInfo.vue
// module id = 115
// module chunks = 1